// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"signUpBanner__root__2yKK7","sticky":"signUpBanner__sticky__3vKgX"};